
import React from "react";
import { useUserReports } from "@/hooks/useUserReports";
import { useProfile } from "@/hooks/useProfile";
import { Card, CardContent } from "@/components/ui/card";
import { ReportsList } from "@/components/reports/ReportsList";
import { ReportLoading } from "@/components/reports/ReportLoading";
import { NoReportsFound } from "@/components/reports/NoReportsFound";
import { ReportsHeader } from "@/components/reports/ReportsHeader";
import { ReportsPagination } from "@/components/reports/ReportsPagination";
import { ReportsSearch } from "@/components/reports/ReportsSearch";

const TeacherReportsPage: React.FC = () => {
  const { profile } = useProfile();
  const { 
    reports, 
    loading, 
    currentPage, 
    totalPages, 
    searchQuery,
    sortField,
    sortDirection,
    handleSearch,
    handleSort,
    handlePageChange, 
    formatDate, 
    formatTime 
  } = useUserReports(profile?.teacher_id ?? undefined);

  return (
    <div className="container max-w-4xl mx-auto px-4 py-8">
      <ReportsHeader />

      <Card className="shadow-lg">
        <CardContent className="p-6">
          <ReportsSearch 
            onSearch={handleSearch}
            initialQuery={searchQuery}
          />
          
          {loading ? (
            <ReportLoading />
          ) : reports.length > 0 ? (
            <>
              <ReportsList 
                reports={reports} 
                formatDate={formatDate} 
                formatTime={formatTime}
                showTeacherDisplay={false}
                showAdminColumns={false}
                sortField={sortField}
                sortDirection={sortDirection}
                onSort={handleSort}
              />
              
              {totalPages > 1 && (
                <ReportsPagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              )}
            </>
          ) : (
            <NoReportsFound />
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default TeacherReportsPage;
